import React from 'react';
import Nav from '../components/Nav';
import Hero from '../components/Hero';
import Overview from '../components/Overview';
import KeyFeatures from '../components/KeyFeatures';
import Curriculum from '../components/Curriculum';
import Projects from '../components/Projects';
import RealTimeProjects from '../components/RealTimeProjects';
import CareerPlacement from '../components/CareerPlacement';
import PlacementPilot from '../components/PlacementPilot';
import Careers from '../components/Careers';
import Certifications from '../components/Certifications';
import Fee from '../components/Fee';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="font-manrope">
      <Nav/>
      <Hero/>
      <Overview/>
      <KeyFeatures/>
      <Curriculum/>
      <Projects/>
      <RealTimeProjects/>
      <CareerPlacement/>
      <PlacementPilot/>
      <Careers/>
      <Certifications/>
      <Fee/>
      <Footer/>
    </div>
  );
}
